module.exports = __webpack_public_path__ + "img/uniformes-y-ropa.04c3832d.png";